import JackImg from "../../assets/images/Jack.jpg";
import AndyImg from "../../assets/images/Andy.jpg";
import JinImg from "../../assets/images/Jin.jpg";
import GraceImg from "../../assets/images/Grace.jpg";
import DriImg from "../../assets/images/Dri.jpg";
import GeorgeImg from "../../assets/images/George.jpg";

export const data = [
    {
        id: 1,
        name: "Jack Wang",
        title: "Founder, CEO",
        image: JackImg,
        slogan: "I am Jack. we are the best team in the world. I am Jack. we are the best team in the world.",
    },
    {
        id: 2,
        name:"Andy",
        title: "CEO",
        image: AndyImg,
        slogan: "I am Andy. we are the best.",
    },
    {
        id: 3,
        name:"Jin",
        title: "CTO",
        image: JinImg,
        slogan: "I am Jack. we are the best team in the world.",
    },
    {
        id: 4,
        name:"Grace",
        title: "CFO",
        image: GraceImg,
        slogan: "I am Jack. we are the best team in the world.",
    },
    {
        id: 5,
        name:"Dri",
        title: "COO",
        image: DriImg,
        slogan: "I am Jack. we are the best team in the world.",
    },
    {
        id: 6,
        name:"George",
        title: "CIO",
        image: GeorgeImg,
        slogan: "I am Jack. we are the best team in the world.",
    }
]